module.exports = __webpack_public_path__ + "img/status1.b95781ae.svg";